export const getCountryCode = exportPrice => exportPrice?.country_code || exportPrice?.country?.code

export const getExportPriceByCountry = (exportPrices, countryCode) => {
  return exportPrices?.find(exportPrice => getCountryCode(exportPrice) === countryCode)
}

export const updateExportPrice = (exportPrices, countryCode, field, value) => {
  const newExportPrice = { country_code: countryCode, [field]: value }

  if (!exportPrices) return [newExportPrice]
  if (!getExportPriceByCountry(exportPrices, countryCode)) return [...exportPrices, newExportPrice]

  return exportPrices.map(exportPrice => {
    if (getCountryCode(exportPrice) !== countryCode) return exportPrice

    return { ...exportPrice, [field]: value }
  })
}

export const isMissingExportPrice = exportPrice => !Number(exportPrice?.price)
